import React, { useState, useEffect } from 'react';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import "../../styles/select-plan.scss";
import CTAButton from "../../components/LandingPage/Common/CTAButton";
import { sendAnalyticsEvent } from '../../utils/SendAnalyticsEvent';

function PurchaseSuccess() {
    document.title="iWantTFC - Discover | Purchase Successful";
    const [timer, setTimer] = useState(10);
    useEffect(() => {
        setTimeout(function () {
            if (timer > 0) {
                setTimer(timer - 1);
            } else {
                window.location.href = process.env.REACT_APP_IWANTTFC_HOMEPAGE;
            }
        }, 1000)

    }, [timer]);
    
    useEffect(() => {
        sendAnalyticsEvent("changePlanSuccessRender", {}, "Purchase Journey", "Discover page");
    }, []);

    return (
        <div className="body" style={{ backgroundImage: 'url(' + process.env.PUBLIC_URL + '/images/footer-bg.png)' }}>
            <Header />
            <div className="ec-container purchase">
                <div className="text-container">
                    <img alt="success icon" src={process.env.PUBLIC_URL + '/images/icons/icon-success.svg'} />
                    <p className="text-center">Transaction Completed</p>
                    <p className="text-center">Successfully!</p>
                </div>
                <p className="label timer"><span>{timer > 0 ? "Redirecting you back in.. " + timer + "s" : "Redirecting now.."}</span></p>
                <CTAButton link={process.env.REACT_APP_IWANTTFC_HOMEPAGE} text="Continue" />
            </div>
            <Footer bg="false" />
        </div>
    );
}

export default PurchaseSuccess;